
import { fetchEmailVerify } from "../../../api/userManagement/getEmailVerify.service";
import {FETCH_EMAIL_VERIFY} from "../actionTypes";


const requestListRequest = ()=>({type: FETCH_EMAIL_VERIFY.REQUEST})
const requestListFailure = (error)=>({type: FETCH_EMAIL_VERIFY.FAILURE, error})
const requestListSuccess = (obj)=>({type: FETCH_EMAIL_VERIFY.SUCCESS, obj})

export const getEmailToVerify = (email)=>{
    return (dispatch, getState)=>{        
        dispatch(requestListRequest()) 
        return fetchEmailVerify(email)  
        .then((res) => {
            dispatch(requestListSuccess(res));
            return Promise.resolve({res:res,status:true});
          })
        .catch(error => {
            dispatch(requestListFailure(error?.message))
            return Promise.resolve({error:error?.message,status:false});
        })
    }
}